import z from "zod";

export const partnershipReportReferenceFormSchema = z.object({
	state: z.enum(["pending", "approved"]).nullish(),
	invoiceNumber: z.string().nullish(),
});

export type PartnershipReportReferenceFormSchema = z.infer<
	typeof partnershipReportReferenceFormSchema
>;
